import gsap from "gsap";

function setupScrollingText(container, index) {
  const spans = Array.from(container.querySelectorAll("span"));
  spans.slice(1).forEach((span) => span.remove());

  const span = container.querySelector("span");
  const repeatCount = Math.ceil(container.offsetWidth / span.offsetWidth) + 1;
  for (let i = 1; i < repeatCount; i++) {
    container.appendChild(span.cloneNode(true));
  }
  const allSpans = container.querySelectorAll("span");
  const fromX = index % 2 === 0 ? "0%" : "-100%";
  const toX = index % 2 === 0 ? "-100%" : "0%";
  gsap.killTweensOf(allSpans);
  gsap.fromTo(
    allSpans,
    { x: fromX },
    { x: toX, duration: 20, ease: "linear", repeat: -1 }
  );
}

export default {
  init() {
    const containers = document.querySelectorAll(".scrolling-text__inner");
    containers.forEach(setupScrollingText);

    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        containers.forEach(setupScrollingText);
      }, 150);
    });
  },
};
